import _ from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ImageUtils from 'arbitrip-common/client/utils/ImageUtils';
import helpers from './helpers';
import moment from 'moment/moment';

const date_format = 'D MMM YYYY';

const SettlePaymentHotelSummary = ({ booking }) => {
	const { t } = useTranslation();
	const hotel = _.get(booking, 'hotel');

	const childrenCount = (booking.deal.details.children_count || 0) * (booking.deal.details.room_count || 1);
	const travelersText =
		booking.travelers.length + childrenCount > 1
			? t('TravelerPluralWithCount', {
					count: booking.travelers.length + (childrenCount),
				})
			: t('Traveler');

	const checkIn = useMemo(() => {
		const date = _.get(booking, 'deal.details.check_in');
		if (moment.isMoment(date)) {
			return date.format(date_format);
		}
	}, [booking]);

	const checkOut = useMemo(() => {
		const date = _.get(booking, 'deal.details.check_out');
		if (moment.isMoment(date)) {
			return date.format(date_format);
		}
	}, [booking]);

	const getPayLaterDeadlineFormat = () => {
		return moment(booking.pay_later_deadline).format(date_format);
	};

	const getCancallationDeadlineFormat = () => {
		const date = moment(booking?.deal?.dca?.dealIsFullyRefundableTill).startOf('day').subtract(1, 'minute');
		return date.format(date_format);
	};

	return (
		<div className="settle-payment-hotel-summary">
			<div className="hotel-image">
				<img
					className="settle-payment-hotel-summary__image"
					src={`${ImageUtils.getHotelImage(hotel)}`}
					loading="lazy"
					decoding="async"
					alt=""
					onError={(i) => (i.target.style.display = 'none')}
				/>
			</div>
			<div className="settle-payment-hotel-summary__item">
				<div className="settle-payment-hotel-summary__item-title">{t('Hotel Name')}</div>
				<div className="settle-payment-hotel-summary__item-content">{hotel.name}</div>
			</div>
			<div className="flex space-between">
				<div className="flex-column">

					{/*Travelers*/}
					<div className="settle-payment-hotel-summary__item">
						<div className="settle-payment-hotel-summary__item-title">{travelersText}</div>
						<div className="settle-payment-hotel-summary__item-content">
							{helpers.getTravelersText(booking, t)}
						</div>
					</div>

					{/*CheckIn*/}
					<div className="settle-payment-hotel-summary__item">
						<div className="settle-payment-hotel-summary__item-title">{t('CheckIn')}</div>
						<div className="settle-payment-hotel-summary__item-content">{checkIn}</div>
					</div>

					{/*Payment Deadline*/}
					<div className="settle-payment-hotel-summary__item">
						<div className="settle-payment-hotel-summary__item-title">{t('Bookings.SettlePayment.PaymentDeadline')}</div>
						<div className="settle-payment-hotel-summary__item-content pending">{getPayLaterDeadlineFormat()}</div>
					</div>
				</div>
				<div className="flex-column">

					{/*Reservation ID*/}
					<div className="settle-payment-hotel-summary__item">
						<div className="settle-payment-hotel-summary__item-title">{t('ReservationID')}</div>
						<div className="settle-payment-hotel-summary__item-content">
							{booking.short_id || booking._id}
						</div>
					</div>

					{/*CheckOut*/}
					<div className="settle-payment-hotel-summary__item">
						<div className="settle-payment-hotel-summary__item-title">{t('CheckOut')}</div>
						<div className="settle-payment-hotel-summary__item-content">{checkOut}</div>
					</div>

					{/*Cancellation Deadline*/}
					<div className="settle-payment-hotel-summary__item">
						<div className="settle-payment-hotel-summary__item-title">{t('Bookings.Filter.CancellationDeadline')}</div>
						<div className="settle-payment-hotel-summary__item-content success">{getCancallationDeadlineFormat()}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SettlePaymentHotelSummary;
